import { useQueryExec } from "../hooks/useQueryExec";
import { IonItem, IonLabel } from "@ionic/react";
import DefaultQueries from "./DefaultQueries";
import { useContext } from "react";
import { TranslationsContext } from "../util/Translations";

const DefaultEmployeeQuery: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { getQueryList, queryList } = useQueryExec(
    "Resource",
    "Employee",
    "employee"
  );
  const querySection = "QW--Resource";
  const { translations } = useContext(TranslationsContext);

  return (
    <>
      <IonItem>
        <IonLabel position="stacked">
          {translations["lbl_mob_employeequery"] || "Default Employee Query"}
        </IonLabel>
        <DefaultQueries
          getQueryList={getQueryList}
          queryList={queryList}
          querySection={querySection}
          disabled={disabled}
        />
      </IonItem>
    </>
  );
};
export default DefaultEmployeeQuery;
